export default __webpack_public_path__ + "3fa7218159d9d9accf70c818530296f3.svg";